module.exports = __webpack_public_path__ + "img/pexels-francesco-ungaro-1525041.4671f8c9.jpg";